import { QRCodeCanvas } from "qrcode.react";
import { Spin, Typography } from "antd";

const { Text, Title } = Typography;

export const QrCode2FA = ({ otpAuthUrl, loading }) => (
  <div
    style={{
      background:
        "radial-gradient(circle at top left, #ebf5ff 0%, #f4f8fd 40%, #ffffff 100%)",
      border: "1px solid #d6e5f7",
      borderRadius: 14,
      padding: 20,
    }}
  >
    <Title
      level={5}
      style={{ marginBottom: 6, color: "#1f3d66", fontWeight: 700 }}
    >
      Escaneie o QR Code no seu app autenticador
    </Title>

    <Text style={{ display: "block", color: "#5c6f85", marginBottom: 16 }}>
      Use Google Authenticator, Microsoft Authenticator ou app compativel.
    </Text>

    <div
      style={{
        background: "#ffffff",
        border: "1px solid #dfe9f5",
        borderRadius: 12,
        padding: 16,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 252,
        boxShadow: "0 10px 24px rgba(18, 64, 120, 0.08)",
      }}
    >
      {loading ? (
        <Spin size="large" tip="Carregando QR Code..." />
      ) : otpAuthUrl ? (
        <QRCodeCanvas value={otpAuthUrl} size={220} bgColor="#ffffff" />
      ) : (
        <Text style={{ color: "#7f8ea0" }}>
          Nao foi possivel carregar o QR Code.
        </Text>
      )}
    </div>
  </div>
);
